<template>
  <aside class="order-info">
    <div class="order-detail" v-show="successSign">
      <p class="order-status">{{orderStatu}}</p>
      <template v-if="taoType">
        <div class="order-info">
          <!--<img width="50" height="50" :src="goodsImg" />-->
          <!--<span class="goods-name">{{goodsName}}</span>-->
          <span class="order-no">运单编号: {{orderNo}}</span>
        </div>
      </template>
      <template v-if="!taoType">
        <div class="order-info">
          <!--<img width="50" height="50" :src="companyLogo" />-->
          <!--<span class="logistics-info">{{logisticsInfo}}<br>{{logisticsTime}}</span>-->
          <span class="order-no">运单编号: {{orderNo}}</span>
        </div>
      </template>
    </div>
    <template v-if="taoType">
      <div class="order-tip" v-show="hasInfo">
        <p v-show="status.query">您是否需要加急派件？<span class="btn" @click="urgentConfirm" data-spm="2263465">加急</span></p>
        <p v-show="status.confirm">已为您申请加急派送，请保持电话畅通！</p>
        <p v-show="status.expect">亲，包裹预计 {{receiveDate}} 到达 <span class="shadow">（仅供参考）</span></p>
        <p v-show="status.delay">亲，快递小哥因为{{delayReason}}不能送小包回家了，<br/>请赶快联系淘宝商家哦</p>
      </div>
    </template>
    <div class="additional-info clearfix">
      <h3 class="info-title">常用功能</h3>
      <div class="icon-item">
        <a href="//order.sto.cn/" data-spm-protocol="i" target="_blank" data-spm="2263463"><i class="p-icon icon-circle order-icon"> </i></a>
        <a href="//order.sto.cn/" data-spm-protocol="i" target="_blank" data-spm="2263463"><p class="icon-describe">我要寄件</p></a>
      </div>
      <div class="icon-item">
        <a href="//site.sto.cn" data-spm-protocol="i" target="_blank"><i class="p-icon icon-circle network-icon"> </i></a>
        <a href="//site.sto.cn" data-spm-protocol="i" target="_blank"><p class="icon-describe">网点查询</p></a>
      </div>
    </div>
    <div class="stay-bottom">
      <span>阿里小蜜提供底层服务支持</span>
    </div>
  </aside>
</template>

<script>
  export default {
    data() {
      return {
        successSign: false,
        taoType: '',
        hasInfo: '',
        goodsImg: '',
        companyLogo: '',
        orderStatu: '',
        goodsName: '',
        logisticsInfo: false,
        logisticsTime: '',
        orderNo: '',
        status: {query: false, confirm: false, expect: false, delay: false},
        receiveDate: ''
      }
    },
    events: {
      'update-logistics': function(data) {
        var me = this;
        // 显示物流信息
        me.successSign = true;
        // 判断是否为淘系运单
        if(data.taobaoOrder=='true') {
          // 淘系订单显示商品详情
          me.taoType = true;
          me.goodsImg = data.auctionPictUrl;
          me.goodsName = data.auctionTitle;
          me.hasInfo = true;
          // 显示不同物流状态
          switch(data.expressionType) {
            case '1':
              me.status = {query: false, confirm: false, expect: true, delay: false};
              me.receiveDate = data.expressionDesc.split(' ')[0];
              break;
            case '2':
              me.status = {query: false, confirm: false, expect: false, delay: true};
              me.delayReason = data.expressionDesc;
              break;
            case '3':
              if(data.expressionDesc=='true')
                me.status = {query: false, confirm: true, expect: false, delay: false};
              else
                me.status = {query: true, confirm: false, expect: false, delay: false};
              break;
            default:
              me.hasInfo = false;
              break;
          }
        }
        else {
          // 非淘系运单显示物流公司信息和物流详情
          me.taoType = false;
          me.companyLogo = data.companyLogo;
          me.logisticsInfo = data.traceDetailDesc;
          me.logisticsTime = data.traceDetailTime;
        }
        me.orderStatu = data.status;
        me.orderNo = data.mailNo;
      }
    },
    methods:{
      // 加急请求
      urgentConfirm: function(){
        this.status = {query: false, confirm: true, expect: false, delay: false};
        this.$dispatch('urgent-order');
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/base";

  @font-face {
    font-family: 'platform';
    src: url('//at.alicdn.com/t/font_1476152775_3890975.eot'); /* IE9*/
    src: url('//at.alicdn.com/t/font_1476152775_3890975.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('//at.alicdn.com/t/font_1476152775_3890975.woff') format('woff'), /* chrome、firefox */
    url('//at.alicdn.com/t/font_1476152775_3890975.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
    url('//at.alicdn.com/t/font_1476152775_3890975.svg#iconfont') format('svg'); /* iOS 4.1- */
  }

  .p-icon {
    font-family: 'platform';
  }

  .order-icon:before {
    content: '\e620';
  }
  /*.icon-circle:before {*/
    /*content: '\e605';*/
  /*}*/
  .network-icon:before {
    content: '\e621';
  }

  aside {
    float: left;
    margin-top: 70px;
    margin-left: -300px;
    width: 300px;
    height: 100%;
    background: #fff;
    .order-title {
      padding: 5px 10px;
      font-size: 14px;
      line-height: 20px;
      img {
        vertical-align: bottom;
      }
    }
    .order-detail {
      padding: 10px;
      background-color: #fff;
      font-size: 14px;
      border-bottom: 1px solid @borderGray;
      .order-status {
        color: @orange;
        font-size: 16px;
        font-weight: 600;
      }
      .order-info {
        margin-top: 10px;
        min-height: 50px;
        img {
          margin-right: 10px;
          float: left;
        }
        span {
          font-size: 12px;
          line-height: 18px;
          display: block;
          margin-left: 60px;
        }
        .goods-name, .logistics-info {
          color: @darkGray;
        }
        .order-no {
          color: @gray;
        }
      }
    }
    .order-tip {
      background-color: #f2f2f2;
      padding: 10px;
      color: @gray;
      font-size: 12px;
      line-height: 18px;
    }
    .stay-bottom {
      position: absolute;
      width: 300px;
      text-align: center;
      bottom: 10px;
      color: @borderGray;
      font-size: 12px;
    }
    .additional-info {
      padding: 15px 10px;
      border-bottom: 1px solid @borderGray;
      .info-title {
        font-size: 14px;
        color: #333;
        margin-bottom: 20px;
      }
      .icon-item {
        display: inline-block;
        width: 50%;
        float: left;
        text-align: center;
        padding: 10px 0;
        .icon-circle {
          width: 50px;
          height: 50px;
          font-size: 32px;
          line-height: 50px;
          color: #6e797a;
          display: block;
          margin: 0 auto;
          border: 1px solid #e6e6e6;
          border-radius: 50%;
          box-sizing: border-box;
          background-color: #fafafa;
        }
        .icon-describe {
          font-size: 14px;
          padding-top: 10px;
          color: #333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// OrderContainer.vue?aeea764c